import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";

// /app/* is claimed by the mobile app (see wellknown/<env>/.well-known/apple-app-site-association).
// Reaching here means the app didn't open it, so fall back to the same path on the web.
@Injectable()
export class AppDeepLinkGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const webUrl = '/' + state.url.replace(/^\/app\/?/i, '').replace(/^[/\\]+/, '');
    this.router.navigateByUrl(webUrl, { replaceUrl: true })
      .catch(() => this.router.navigateByUrl('/', { replaceUrl: true }));
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/guard/app-deep-link.guard.ts